<p-dialog
  [(visible)]="dialog"
  [style]="{ width: '75vw', height: '75vw' }"
  header="Contrato"
  [modal]="true"
  styleClass="p-fluid"
  (onHide)="escondeDialog()"
>
  <ng-template pTemplate="header">
    <app-header titulo="Contrato" descricao="Exibição de contrato">
    </app-header>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="grid grid-nogutter" style="width: 60vw">
        <div class="col-2"><b>Contrato:</b> {{ contrato.idContrato }}</div>
        <div class="col-2"><b>Instância:</b> {{ contrato.instancia }}</div>
        <div class="col-2"><b>Empresa ERP:</b> {{ contrato.cdEmpresaErp }}</div>
        <div class="col-2"><b>Filial ERP:</b> {{ contrato.cdFilialErp }}</div>
        <div class="col-4"><b>Tipo Contrato:</b> {{ contrato.cdTpContr }}</div>

        <div class="col-3"><b>Fornecedor PIMS/ERP:</b> {{ contrato.cdFornecPims }}/{{ contrato.cdFornecErp }}</div>
        <div class="col-3"><b>Fazenda:</b> {{ contrato.cdUpnivel1 }}</div>
        <div class="col-3"><b>Início Vigência:</b> {{ contrato.dtInicVigencia | date: 'dd/MM/yyyy' }}</div>
        <div class="col-3"><b>Fim Vigência:</b> {{ contrato.dtFinVigencia | date: 'dd/MM/yyyy' }}</div>

        <div class="col-12"><b>Descrição:</b> {{ contrato.deContrato }}</div>

        <div class="col-2"><b>UF:</b> {{ contrato.cdUf }}</div>
        <div class="col-2"><b>Tipo Parcela:</b> {{ contrato.fgPerParcela }}</div>
        <div class="col-2"><b>Tipo Propriedade:</b> {{ contrato.tpPropriedade }}</div>
        <div class="col-2"><b>Área:</b> {{ contrato.qtArea }}</div>
        <div class="col-4"><b>Dia pagamento:</b> {{ contrato.diaPagto }}</div>

        <div class="col-2"><b>Status:</b> {{ contrato.fgStatusInteg }}</div>
        <div class="col-10"><b>Mensagem ERP:</b> {{ contrato.mensagemErp }} </div>
    </div>

    <p-tabView>
      <p-tabPanel header="Parcelas">
        <p-table
          [value]="contrato.parcelas"
          [paginator]="true"
          [rows]="100"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
          [rowsPerPageOptions]="[20, 50, 100]"
          [scrollable]="true"
          scrollHeight="35rem"
          [resizableColumns]="true"
          [tableStyle]="{
            'font-size': '.9rem',
            'font-weight': '400',
            'border-spacing': '0 0 !important',
            'border-colapse': 'separate'
          }"
          #dt
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="idContrato">
                Parcela <p-sortIcon field="idContrato"></p-sortIcon>
              </th>
              <th pSortableColumn="instancia">
                Data Parcela <p-sortIcon field="instancia"></p-sortIcon>
              </th>
              <th pSortableColumn="instancia">
                Data Pagamento <p-sortIcon field="instancia"></p-sortIcon>
              </th>
              <th pSortableColumn="cdEmpresaErp">
                Valor <p-sortIcon field="cdEmpresaErp"></p-sortIcon>
              </th>
              <th pSortableColumn="dtInicVigencia">
                Situação <p-sortIcon field="dtInicVigencia"></p-sortIcon>
              </th>
              <th pSortableColumn="dtFinVigencia">
                Cana Mês <p-sortIcon field="dtFinVigencia"></p-sortIcon>
              </th>
              <th pSortableColumn="cdFornecErp">
                Indíce <p-sortIcon field="cdFornecErp"></p-sortIcon>
              </th>
              <th pSortableColumn="cdUpnivel1">
                Tipo <p-sortIcon field="cdUpnivel1"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-parcela>
            <tr [pSelectableRow]="contrato">
              <td>{{ parcela.idParcela }}</td>
              <td>{{ parcela.dtHistorico | date : "dd/MM/yyyy" }}</td>
              <td>{{ parcela.dtPagto | date : "dd/MM/yyyy" }}</td>
              <td>{{ parcela.vlHistorico.toLocaleString("pt-BR", { style: 'currency', currency: 'BRL' }) }}</td>
              <td>{{ parcela.fgSituacao }}</td>
              <td>{{ parcela.canaMes }}</td>
              <td>{{ parcela.indice.toLocaleString("pt-BR", { style: 'currency', currency: 'BRL' }) }}</td>
              <td>{{ parcela.fgTpPagto }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Favorecidos">
        <p-table
          [value]="contrato.favorecidos"
          [paginator]="true"
          [rows]="100"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros"
          [rowsPerPageOptions]="[20, 50, 100]"
          [scrollable]="true"
          scrollHeight="40.5rem"
          [resizableColumns]="true"
          [tableStyle]="{
            'font-size': '.9rem',
            'font-weight': '400',
            'border-spacing': '0 0 !important',
            'border-colapse': 'separate'
          }"
          #dt
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="idContrato">
                Fornecedor PIMS <p-sortIcon field="idContrato"></p-sortIcon>
              </th>
              <th pSortableColumn="instancia">
                Fornecedor ERP <p-sortIcon field="instancia"></p-sortIcon>
              </th>
              <th pSortableColumn="instancia">
                % <p-sortIcon field="instancia"></p-sortIcon>
              </th>
              <th pSortableColumn="cdEmpresaErp">
                Status <p-sortIcon field="cdEmpresaErp"></p-sortIcon>
              </th>
              <th pSortableColumn="dtInicVigencia">
                Data PIMS <p-sortIcon field="dtInicVigencia"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-favorecido>
            <tr [pSelectableRow]="contrato">
              <td>{{ favorecido.cdFornecPims }}</td>
              <td>{{ favorecido.cdFornecErp }}</td>
              <td>{{ favorecido.qtPercentFav }}</td>
              <td>{{ favorecido.fgStatusInteg }}</td>
              <td>{{ favorecido.dtEnvioPims | date : "dd/MM/yyyy" }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer"> </ng-template>
</p-dialog>
